<div class="flex flex-col gap-2">
    <div class="font-bold sm:pt-0 text-ponder-light">
        <span class="text-base">View Set</span>
    </div>
    <div class="flex flex-col bg-slate-100 rounded shadow min-w-64">
        @if (isLoading || !loadingSuccess) {
            <loading class="p-16" [isLoading]="isLoading" [success]="loadingSuccess"/>
        } @else {
            <div class="flex flex-col gap-1 p-2 bg-slate-50 rounded-t">
                <div class="flex flex-row gap-2 items-center">
                    <div class="w-[12ch] text-right">Name:</div>
                    <div class="p-[5px] rounded-sm shadow-sm bg-white w-[48ch] truncate">{{ selectedMagicSet.name! }}</div>
                </div>
                <div class="flex flex-row gap-2 items-center">
                    <div class="w-[12ch] text-right">Code:</div>
                    <div class="p-[5px] rounded-sm shadow-sm bg-white w-[48ch]">{{ selectedMagicSet.code! }}</div>
                </div>
                <div class="flex flex-row gap-2 items-center">
                    <div class="w-[12ch] text-right">Released:</div>
                    <div class="p-[5px] rounded-sm shadow-sm bg-white w-[48ch]">{{ selectedMagicSet.releaseDate | date }}</div>
                </div>
                <div class="flex flex-row gap-2 items-center">
                    <div class="w-[12ch] text-right">Type:</div>
                    <div class="p-[5px] rounded-sm shadow-sm bg-white w-[48ch]">{{ selectedMagicSet.type }}</div>
                </div>
                <div class="flex flex-row gap-2 items-center">
                    <div class="w-[12ch] text-right">Parent Set:</div>
                    <div class="p-[5px] rounded-sm shadow-sm bg-white w-[48ch]">{{ selectedMagicSet.parentId ?? "&nbsp;" }}</div>
                </div>
                <div class="flex flex-row gap-2 items-center">
                    <div class="w-[12ch] text-right">Parent Block:</div>
                    <div class="p-[5px] rounded-sm shadow-sm bg-white w-[48ch]">{{ selectedMagicSet.blockId ?? "&nbsp;" }}</div>
                </div>
                <div class="flex flex-row gap-2 items-center" title="Contains cards from products outside of the Magic setting. Such as: Lord of the Rings, Warhammer, DND, Marvel, etc.">
                    <div class="flex flex-row justify-end w-[12ch]">
                        <input type="checkbox" [attr.checked]="(selectedMagicSet.ub ? 'checked' : undefined)">
                    </div>
                    <div>Universes Beyond</div>
                </div>
            </div>
            <div class="flex flex-row gap-2 p-2 border-t items-end justify-end">
                <input #viewMagicSetFilter (input)="onMagicSetFilterChange(viewMagicSetFilter.value)" class="p-[5px] rounded-sm shadow-sm bg-white w-[8ch] text-center" placeholder="set">
                <select #viewMagicSetSelect (change)="onMagicSetSelected(viewMagicSetSelect.value)" class="p-[5px] rounded-sm shadow-sm bg-white grow">
                    @for (set of visibleMagicSets ; track set.id!) {
                        <option [attr.value]="set.code!">{{ set.name! }} ({{ set.code! }})</option>
                    }
                </select>
            </div>
        }
    </div>
</div>